module.exports = __webpack_public_path__ + "static/word_html_format_example-1583e237a4bf8fff93156e24e6f3cbc6.png";